module.exports = __webpack_public_path__ + "210a7c781f5a354a0e4985656ab456d9.woff";


//////////////////
// WEBPACK FOOTER
// ./node_modules/typeface-roboto/files/roboto-latin-300italic.woff
// module id = 662
// module chunks = 0